(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["case-studies"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const section = document.querySelector('.case-studies');
    if (!section) return;

    const searchInput = document.getElementById('case-studies-search');
    const filterBtns = section.querySelectorAll('.case-studies__filter-btn');
    const cards = Array.from(section.querySelectorAll('.case-studies__card'));
    const paginationEl = document.getElementById('case-studies-pagination');
    const countEl = document.getElementById('case-studies-count');
    const filtersWrapEl = section.querySelector('.case-studies__filters-wrap');
    const cardsPerPage = parseInt(section.dataset.cardsPerPage || '6', 10);

    function scrollToFiltersWrap() {
      if (filtersWrapEl) filtersWrapEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function getPageFromUrl() {
      const params = new URLSearchParams(window.location.search);
      const p = parseInt(params.get('case_studies_page') || '1', 10);
      return p > 0 ? p : 1;
    }

    function setPageInUrl(page) {
      const url = new URL(window.location.href);
      if (page <= 1) {
        url.searchParams.delete('case_studies_page');
      } else {
        url.searchParams.set('case_studies_page', String(page));
      }
      window.history.replaceState({}, '', url.toString());
    }

    function getSearchQuery() {
      return (searchInput && searchInput.value ? searchInput.value.trim() : '').toLowerCase();
    }

    function cardMatchesSearch(card, query) {
      if (!query) return true;
      var text = (card.dataset.searchable || '').toLowerCase();
      return text.indexOf(query) !== -1;
    }

    function getVisibleCards() {
      var query = getSearchQuery();
      return cards.filter(function (card) {
        if (card.classList.contains('is-hidden')) return false;
        return cardMatchesSearch(card, query);
      });
    }

    function applyPagination() {
      const visible = getVisibleCards();
      const totalPages = Math.max(1, Math.ceil(visible.length / cardsPerPage));
      let currentPage = getPageFromUrl();
      if (currentPage > totalPages) currentPage = totalPages;
      if (currentPage < 1) currentPage = 1;
      setPageInUrl(currentPage);

      const start = (currentPage - 1) * cardsPerPage;
      const end = start + cardsPerPage;

      cards.forEach(function (card) {
        var inVisible = visible.indexOf(card) !== -1;
        card.classList.toggle('case-studies__card--search-hidden', !inVisible);
      });

      visible.forEach(function (card, index) {
        var onPage = index >= start && index < end;
        card.classList.toggle('case-studies__card--page-hidden', !onPage);
      });

      if (countEl) {
        countEl.textContent = 'Showing ' + visible.length + ' case study' + (visible.length === 1 ? '' : ' studies');
      }
      renderPagination(visible.length, currentPage, totalPages);
    }

    function renderPagination(totalVisible, currentPage, totalPages) {
      if (!paginationEl) return;
      paginationEl.innerHTML = '';
      if (totalPages <= 1 && totalVisible <= cardsPerPage) {
        paginationEl.hidden = true;
        return;
      }
      paginationEl.hidden = false;

      var ul = document.createElement('ul');
      ul.className = 'case-studies__pagination-list';
      ul.setAttribute('role', 'list');

      var prevLi = document.createElement('li');
      if (currentPage <= 1) {
        var span = document.createElement('span');
        span.className =
          'case-studies__pagination-span case-studies__pagination-link case-studies__pagination-link--arrow case-studies__pagination-span--disabled';
        span.setAttribute('aria-disabled', 'true');
        span.innerHTML = 'Previous';
        prevLi.appendChild(span);
      } else {
        var a = document.createElement('a');
        a.href = '#';
        a.className = 'case-studies__pagination-link case-studies__pagination-link--arrow';
        a.setAttribute('aria-label', 'Previous page');
        a.textContent = 'Previous';
        a.addEventListener('click', function (e) {
          e.preventDefault();
          setPageInUrl(currentPage - 1);
          applyPagination();
          scrollToFiltersWrap();
        });
        prevLi.appendChild(a);
      }
      ul.appendChild(prevLi);

      for (var i = 1; i <= totalPages; i++) {
        var li = document.createElement('li');
        if (i === currentPage) {
          var spanCur = document.createElement('span');
          spanCur.className = 'case-studies__pagination-link case-studies__pagination-link--active';
          spanCur.setAttribute('aria-current', 'page');
          spanCur.textContent = i;
          li.appendChild(spanCur);
        } else {
          var aCur = document.createElement('a');
          aCur.href = '#';
          aCur.className = 'case-studies__pagination-link';
          aCur.setAttribute('aria-label', 'Page ' + i);
          aCur.textContent = i;
          aCur.addEventListener('click', function (e) {
            e.preventDefault();
            setPageInUrl(parseInt(this.textContent, 10));
            applyPagination();
            scrollToFiltersWrap();
          });
          li.appendChild(aCur);
        }
        ul.appendChild(li);
      }

      var nextLi = document.createElement('li');
      if (currentPage >= totalPages) {
        var spanNext = document.createElement('span');
        spanNext.className =
          'case-studies__pagination-span case-studies__pagination-link case-studies__pagination-link--arrow case-studies__pagination-span--disabled';
        spanNext.setAttribute('aria-disabled', 'true');
        spanNext.innerHTML = 'Next';
        nextLi.appendChild(spanNext);
      } else {
        var aNext = document.createElement('a');
        aNext.href = '#';
        aNext.className = 'case-studies__pagination-link case-studies__pagination-link--arrow';
        aNext.setAttribute('aria-label', 'Next page');
        aNext.textContent = 'Next';
        aNext.addEventListener('click', function (e) {
          e.preventDefault();
          setPageInUrl(currentPage + 1);
          applyPagination();
          scrollToFiltersWrap();
        });
        nextLi.appendChild(aNext);
      }
      ul.appendChild(nextLi);

      paginationEl.appendChild(ul);
    }

    function applyIndustryFilter() {
      var activeBtn = section.querySelector('.case-studies__filter-btn.is-active');
      var filter = activeBtn ? activeBtn.dataset.filter : 'all';
      cards.forEach(function (card) {
        var cardTopic = (card.dataset.topic || '').trim();
        var show = filter === 'all' || cardTopic === filter;
        card.classList.toggle('is-hidden', !show);
        card.classList.remove('case-studies__card--page-hidden');
      });
    }

    filterBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        filterBtns.forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
          b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
        });
        applyIndustryFilter();
        setPageInUrl(1);
        applyPagination();
      });
    });

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        setPageInUrl(1);
        applyPagination();
      });
      searchInput.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          searchInput.value = '';
          applyPagination();
          searchInput.blur();
        }
      });
    }

    applyPagination();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["in-the-news"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const section = document.querySelector('.in-the-news');
    if (!section) return;

    const filterBtns = section.querySelectorAll('.in-the-news__filter-btn');
    const cards = Array.from(section.querySelectorAll('.in-the-news__card'));
    const paginationEl = document.getElementById('in-the-news-pagination');
    const filtersWrapEl = section.querySelector('.in-the-news__filters-wrap');
    const cardsPerPage = parseInt(section.dataset.cardsPerPage || '6', 10);

    function scrollToFiltersWrap() {
      if (filtersWrapEl) filtersWrapEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function getPageFromUrl() {
      const params = new URLSearchParams(window.location.search);
      const p = parseInt(params.get('page') || '1', 10);
      return p > 0 ? p : 1;
    }

    function setPageInUrl(page) {
      const url = new URL(window.location.href);
      if (page <= 1) {
        url.searchParams.delete('page');
      } else {
        url.searchParams.set('page', String(page));
      }
      window.history.replaceState({}, '', url.toString());
    }

    function getVisibleCards() {
      return cards.filter((card) => !card.classList.contains('is-hidden'));
    }

    function applyPagination() {
      const visible = getVisibleCards();
      const totalPages = Math.max(1, Math.ceil(visible.length / cardsPerPage));
      let currentPage = getPageFromUrl();
      if (currentPage > totalPages) currentPage = totalPages;
      if (currentPage < 1) currentPage = 1;
      setPageInUrl(currentPage);

      const start = (currentPage - 1) * cardsPerPage;
      const end = start + cardsPerPage;

      visible.forEach((card, index) => {
        const onPage = index >= start && index < end;
        card.classList.toggle('in-the-news__card--page-hidden', !onPage);
      });

      renderPagination(visible.length, currentPage, totalPages);
    }

    function renderPagination(totalVisible, currentPage, totalPages) {
      if (!paginationEl) return;
      paginationEl.innerHTML = '';
      if (totalPages <= 1 && totalVisible <= cardsPerPage) {
        paginationEl.hidden = true;
        return;
      }
      paginationEl.hidden = false;

      const ul = document.createElement('ul');
      ul.className = 'in-the-news__pagination-list';
      ul.setAttribute('role', 'list');

      const prevLi = document.createElement('li');
      if (currentPage <= 1) {
        const span = document.createElement('span');
        span.className =
          'in-the-news__pagination-span in-the-news__pagination-link in-the-news__pagination-link--arrow in-the-news__pagination-span--disabled';
        span.setAttribute('aria-disabled', 'true');
        span.innerHTML = 'Previous';
        prevLi.appendChild(span);
      } else {
        const a = document.createElement('a');
        a.href = '#';
        a.className = 'in-the-news__pagination-link in-the-news__pagination-link--arrow';
        a.setAttribute('aria-label', 'Previous page');
        a.textContent = 'Previous';
        a.addEventListener('click', (e) => {
          e.preventDefault();
          setPageInUrl(currentPage - 1);
          applyPagination();
          scrollToFiltersWrap();
        });
        prevLi.appendChild(a);
      }
      ul.appendChild(prevLi);

      for (let i = 1; i <= totalPages; i++) {
        const li = document.createElement('li');
        if (i === currentPage) {
          const span = document.createElement('span');
          span.className = 'in-the-news__pagination-link in-the-news__pagination-link--active';
          span.setAttribute('aria-current', 'page');
          span.textContent = i;
          li.appendChild(span);
        } else {
          const a = document.createElement('a');
          a.href = '#';
          a.className = 'in-the-news__pagination-link';
          a.setAttribute('aria-label', 'Page ' + i);
          a.textContent = i;
          a.addEventListener('click', (e) => {
            e.preventDefault();
            setPageInUrl(i);
            applyPagination();
            scrollToFiltersWrap();
          });
          li.appendChild(a);
        }
        ul.appendChild(li);
      }

      const nextLi = document.createElement('li');
      if (currentPage >= totalPages) {
        const span = document.createElement('span');
        span.className =
          'in-the-news__pagination-span in-the-news__pagination-link in-the-news__pagination-link--arrow in-the-news__pagination-span--disabled';
        span.setAttribute('aria-disabled', 'true');
        span.innerHTML = 'Next';
        nextLi.appendChild(span);
      } else {
        const a = document.createElement('a');
        a.href = '#';
        a.className = 'in-the-news__pagination-link in-the-news__pagination-link--arrow';
        a.setAttribute('aria-label', 'Next page');
        a.textContent = 'Next';
        a.addEventListener('click', (e) => {
          e.preventDefault();
          setPageInUrl(currentPage + 1);
          applyPagination();
          scrollToFiltersWrap();
        });
        nextLi.appendChild(a);
      }
      ul.appendChild(nextLi);

      paginationEl.appendChild(ul);
    }

    filterBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        const filter = btn.dataset.filter;

        filterBtns.forEach((b) => {
          b.classList.toggle('is-active', b === btn);
          b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
        });

        cards.forEach((card) => {
          const rawTags = card.dataset.tags || '';
          const tags = rawTags
            .split(',')
            .map((t) => t.trim())
            .filter(Boolean);
          const show = filter === 'all' || tags.includes(filter);
          card.classList.toggle('is-hidden', !show);
          card.classList.remove('in-the-news__card--page-hidden');
        });

        setPageInUrl(1);
        applyPagination();
      });
    });

    applyPagination();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-videos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const section = document.querySelector('.our-videos');
    if (!section) return;

    const modal = document.getElementById('our-videos-modal');
    const modalTitle = document.getElementById('our-videos-modal-title');
    const modalVideoWrap = document.getElementById('our-videos-modal-video');
    const modalBody = document.getElementById('our-videos-modal-body');
    const modalClose = document.getElementById('our-videos-modal-close');
    const searchInput = document.getElementById('our-videos-search');
    const filterBtns = section.querySelectorAll('.our-videos__filter-btn');
    const cards = Array.from(section.querySelectorAll('.our-videos__card'));
    const paginationEl = document.getElementById('our-videos-pagination');
    const filtersWrapEl = section.querySelector('.our-videos__filters-wrap');
    const cardsPerPage = parseInt(section.dataset.cardsPerPage || '6', 10);

    function scrollToFiltersWrap() {
      if (filtersWrapEl) filtersWrapEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function getPageFromUrl() {
      const params = new URLSearchParams(window.location.search);
      const p = parseInt(params.get('videos_page') || '1', 10);
      return p > 0 ? p : 1;
    }

    function setPageInUrl(page) {
      const url = new URL(window.location.href);
      if (page <= 1) {
        url.searchParams.delete('videos_page');
      } else {
        url.searchParams.set('videos_page', String(page));
      }
      window.history.replaceState({}, '', url.toString());
    }

    function getSearchQuery() {
      return (searchInput && searchInput.value ? searchInput.value.trim() : '').toLowerCase();
    }

    function cardMatchesSearch(card, query) {
      if (!query) return true;
      var text = (card.dataset.searchable || '').toLowerCase();
      return text.indexOf(query) !== -1;
    }

    function getVisibleCards() {
      var query = getSearchQuery();
      return cards.filter(function (card) {
        if (card.classList.contains('is-hidden')) return false;
        return cardMatchesSearch(card, query);
      });
    }

    function applyPagination() {
      const visible = getVisibleCards();
      const totalPages = Math.max(1, Math.ceil(visible.length / cardsPerPage));
      let currentPage = getPageFromUrl();
      if (currentPage > totalPages) currentPage = totalPages;
      if (currentPage < 1) currentPage = 1;
      setPageInUrl(currentPage);

      const start = (currentPage - 1) * cardsPerPage;
      const end = start + cardsPerPage;

      /* Hide cards that don't match search; show only those in visible list */
      cards.forEach(function (card) {
        var inVisible = visible.indexOf(card) !== -1;
        card.classList.toggle('our-videos__card--search-hidden', !inVisible);
      });

      visible.forEach(function (card, index) {
        var onPage = index >= start && index < end;
        card.classList.toggle('our-videos__card--page-hidden', !onPage);
      });

      renderPagination(visible.length, currentPage, totalPages);
    }

    function renderPagination(totalVisible, currentPage, totalPages) {
      if (!paginationEl) return;
      paginationEl.innerHTML = '';
      if (totalPages <= 1 && totalVisible <= cardsPerPage) {
        paginationEl.hidden = true;
        return;
      }
      paginationEl.hidden = false;

      var mobileSimple =
        typeof window !== 'undefined' &&
        window.matchMedia &&
        window.matchMedia('(max-width: 749px)').matches;
      paginationEl.setAttribute(
        'aria-label',
        mobileSimple
          ? 'Videos pagination, page ' + currentPage + ' of ' + totalPages
          : 'Videos pagination'
      );

      var ul = document.createElement('ul');
      ul.className = 'our-videos__pagination-list';
      ul.setAttribute('role', 'list');

      var prevLi = document.createElement('li');
      if (currentPage <= 1) {
        var span = document.createElement('span');
        span.className =
          'our-videos__pagination-span our-videos__pagination-link our-videos__pagination-link--arrow our-videos__pagination-span--disabled';
        span.setAttribute('aria-disabled', 'true');
        span.innerHTML = 'Previous';
        prevLi.appendChild(span);
      } else {
        var a = document.createElement('a');
        a.href = '#';
        a.className = 'our-videos__pagination-link our-videos__pagination-link--arrow';
        a.setAttribute('aria-label', 'Previous page');
        a.textContent = 'Previous';
        a.addEventListener('click', function (e) {
          e.preventDefault();
          setPageInUrl(currentPage - 1);
          applyPagination();
          scrollToFiltersWrap();
        });
        prevLi.appendChild(a);
      }
      ul.appendChild(prevLi);

      function appendPageNumberLi(pageNum) {
        var li = document.createElement('li');
        if (pageNum === currentPage) {
          var spanCur = document.createElement('span');
          spanCur.className = 'our-videos__pagination-link our-videos__pagination-link--active';
          spanCur.setAttribute('aria-current', 'page');
          spanCur.textContent = String(pageNum);
          li.appendChild(spanCur);
        } else {
          var aCur = document.createElement('a');
          aCur.href = '#';
          aCur.className = 'our-videos__pagination-link';
          aCur.setAttribute('aria-label', 'Page ' + pageNum);
          aCur.setAttribute('data-page', String(pageNum));
          aCur.textContent = String(pageNum);
          aCur.addEventListener('click', function (e) {
            e.preventDefault();
            setPageInUrl(parseInt(e.currentTarget.getAttribute('data-page'), 10));
            applyPagination();
            scrollToFiltersWrap();
          });
          li.appendChild(aCur);
        }
        ul.appendChild(li);
      }

      if (mobileSimple) {
        var statusLi = document.createElement('li');
        var statusSpan = document.createElement('span');
        statusSpan.className = 'our-videos__pagination-status';
        statusSpan.setAttribute('aria-current', 'page');
        var curStat = document.createElement('span');
        curStat.className = 'our-videos__pagination-status-current';
        curStat.textContent = String(currentPage);
        var sepStat = document.createElement('span');
        sepStat.className = 'our-videos__pagination-status-sep';
        sepStat.textContent = ' / ';
        var totStat = document.createElement('span');
        totStat.className = 'our-videos__pagination-status-total';
        totStat.textContent = String(totalPages);
        statusSpan.appendChild(curStat);
        statusSpan.appendChild(sepStat);
        statusSpan.appendChild(totStat);
        statusLi.appendChild(statusSpan);
        ul.appendChild(statusLi);
      } else {
        for (var i = 1; i <= totalPages; i++) {
          appendPageNumberLi(i);
        }
      }

      var nextLi = document.createElement('li');
      if (currentPage >= totalPages) {
        var spanNext = document.createElement('span');
        spanNext.className =
          'our-videos__pagination-span our-videos__pagination-link our-videos__pagination-link--arrow our-videos__pagination-span--disabled';
        spanNext.setAttribute('aria-disabled', 'true');
        spanNext.innerHTML = 'Next';
        nextLi.appendChild(spanNext);
      } else {
        var aNext = document.createElement('a');
        aNext.href = '#';
        aNext.className = 'our-videos__pagination-link our-videos__pagination-link--arrow';
        aNext.setAttribute('aria-label', 'Next page');
        aNext.textContent = 'Next';
        aNext.addEventListener('click', function (e) {
          e.preventDefault();
          setPageInUrl(currentPage + 1);
          applyPagination();
          scrollToFiltersWrap();
        });
        nextLi.appendChild(aNext);
      }
      ul.appendChild(nextLi);

      paginationEl.appendChild(ul);
    }

    function getEmbedUrl(url) {
      if (!url || typeof url !== 'string') return '';
      const u = url.trim();
      let id = '';
      if (u.includes('youtube.com/watch')) {
        const match = u.match(/[?&]v=([^&]+)/);
        id = match ? match[1] : '';
        return id ? 'https://www.youtube.com/embed/' + id : '';
      }
      if (u.includes('youtu.be/')) {
        id = u.split('youtu.be/')[1].split('?')[0].split('&')[0];
        return id ? 'https://www.youtube.com/embed/' + id : '';
      }
      if (u.includes('vimeo.com/')) {
        const match = u.match(/vimeo\.com\/(?:video\/)?(\d+)/);
        id = match ? match[1] : '';
        return id ? 'https://player.vimeo.com/video/' + id : '';
      }
      return u;
    }

    function openModal(card) {
      const url = card.dataset.videoUrl || '';
      const embedUrl = getEmbedUrl(url);
      const title = card.dataset.videoTitle || '';
      const date = card.dataset.videoDate || '';
      const duration = card.dataset.videoDuration || '';
      const views = card.dataset.videoViews || '';
      const tag = card.dataset.videoTag || '';

      modalTitle.textContent = title;

      modalVideoWrap.innerHTML = '';
      if (embedUrl) {
        const iframe = document.createElement('iframe');
        iframe.src = embedUrl;
        iframe.title = title;
        modalVideoWrap.appendChild(iframe);
      }

      const descTemplate = card.querySelector('.our-videos__card-full-description');
      let metaHtml = '';
      if (tag)
        metaHtml +=
          '<span class="our-videos__modal-meta-row1"><span class="our-videos__modal-meta-tag">' +
          escapeHtml(tag) +
          '</span></span>';
      if (date)
        metaHtml +=
          '<span><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M8 2v4"/><path d="M16 2v4"/><rect width="18" height="18" x="3" y="4" rx="2"/><path d="M3 10h18"/></svg>' +
          escapeHtml(date) +
          '</span>';
      if (duration)
        metaHtml +=
          '<span><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>' +
          escapeHtml(duration) +
          '</span>';
      if (views)
        metaHtml +=
          '<span><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"/><circle cx="12" cy="12" r="3"/></svg>' +
          (Number(views) >= 1000 ? (Number(views) / 1000).toFixed(1) + 'K' : views) +
          ' views</span>';

      let bodyContent = '';
      if (metaHtml) bodyContent += '<div class="our-videos__modal-meta">' + metaHtml + '</div>';
      if (descTemplate && descTemplate.innerHTML.trim()) {
        bodyContent += descTemplate.innerHTML.trim();
      }
      if (url) {
        const watchLabel = url.includes('youtube') || url.includes('youtu.be') ? 'Watch on YouTube' : 'Watch video';
        bodyContent +=
          '<a href="' +
          escapeAttr(url) +
          '" target="_blank" rel="noopener" class="our-videos__modal-cta">' +
          watchLabel +
          ' <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-right w-5 h-5"><path d="m9 18 6-6-6-6"></path></svg></a>';
      }
      modalBody.innerHTML = bodyContent;

      modal.showModal();
      document.body.style.overflow = 'hidden';
    }

    function escapeHtml(s) {
      const div = document.createElement('div');
      div.textContent = s;
      return div.innerHTML;
    }
    function escapeAttr(s) {
      return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    function closeModal() {
      modal.close();
      document.body.style.overflow = '';
      modalVideoWrap.innerHTML = '';
    }

    modalClose.addEventListener('click', closeModal);
    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });
    modal.addEventListener('cancel', closeModal);
    modal.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        openModal(card);
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openModal(card);
        }
      });
    });

    function applyCategoryFilter() {
      var activeBtn = section.querySelector('.our-videos__filter-btn.is-active');
      var filter = activeBtn ? activeBtn.dataset.filter : 'all';
      cards.forEach(function (card) {
        var rawTags = (card.dataset.tags || '')
          .split(',')
          .map(function (t) {
            return t.trim();
          })
          .filter(Boolean);
        var show = filter === 'all' || rawTags.includes(filter);
        card.classList.toggle('is-hidden', !show);
        card.classList.remove('our-videos__card--page-hidden');
      });
    }

    filterBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const filter = btn.dataset.filter;
        filterBtns.forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
          b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
        });
        applyCategoryFilter();
        setPageInUrl(1);
        applyPagination();
      });
    });

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        setPageInUrl(1);
        applyPagination();
      });
      searchInput.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          searchInput.value = '';
          applyPagination();
          searchInput.blur();
        }
      });
    }

    applyPagination();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["research-projects"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const section = document.querySelector('.research-projects');
    if (!section) return;

    const searchInput = document.getElementById('research-projects-search');
    const filterBtns = section.querySelectorAll('.research-projects__filter-btn');
    const cards = Array.from(section.querySelectorAll('.research-projects__card'));
    const paginationEl = document.getElementById('research-projects-pagination');
    const filtersWrapEl = section.querySelector('.research-projects__filters-wrap');
    const cardsPerPage = parseInt(section.dataset.cardsPerPage || '6', 10);

    function scrollToFiltersWrap() {
      if (filtersWrapEl) filtersWrapEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function getPageFromUrl() {
      const params = new URLSearchParams(window.location.search);
      const p = parseInt(params.get('projects_page') || '1', 10);
      return p > 0 ? p : 1;
    }

    function setPageInUrl(page) {
      const url = new URL(window.location.href);
      if (page <= 1) {
        url.searchParams.delete('projects_page');
      } else {
        url.searchParams.set('projects_page', String(page));
      }
      window.history.replaceState({}, '', url.toString());
    }

    function getSearchQuery() {
      return (searchInput && searchInput.value ? searchInput.value.trim() : '').toLowerCase();
    }

    function cardMatchesSearch(card, query) {
      if (!query) return true;
      var text = (card.dataset.searchable || '').toLowerCase();
      return text.indexOf(query) !== -1;
    }

    function getVisibleCards() {
      var query = getSearchQuery();
      return cards.filter(function (card) {
        if (card.classList.contains('is-hidden')) return false;
        return cardMatchesSearch(card, query);
      });
    }

    function applyPagination() {
      const visible = getVisibleCards();
      const totalPages = Math.max(1, Math.ceil(visible.length / cardsPerPage));
      let currentPage = getPageFromUrl();
      if (currentPage > totalPages) currentPage = totalPages;
      if (currentPage < 1) currentPage = 1;
      setPageInUrl(currentPage);

      const start = (currentPage - 1) * cardsPerPage;
      const end = start + cardsPerPage;

      cards.forEach(function (card) {
        var inVisible = visible.indexOf(card) !== -1;
        card.classList.toggle('research-projects__card--search-hidden', !inVisible);
      });

      visible.forEach(function (card, index) {
        var onPage = index >= start && index < end;
        card.classList.toggle('research-projects__card--page-hidden', !onPage);
      });

      renderPagination(visible.length, currentPage, totalPages);
    }

    function renderPagination(totalVisible, currentPage, totalPages) {
      if (!paginationEl) return;
      paginationEl.innerHTML = '';
      if (totalPages <= 1 && totalVisible <= cardsPerPage) {
        paginationEl.hidden = true;
        return;
      }
      paginationEl.hidden = false;

      var ul = document.createElement('ul');
      ul.className = 'research-projects__pagination-list';
      ul.setAttribute('role', 'list');

      var prevLi = document.createElement('li');
      if (currentPage <= 1) {
        var span = document.createElement('span');
        span.className =
          'research-projects__pagination-span research-projects__pagination-link research-projects__pagination-link--arrow research-projects__pagination-span--disabled';
        span.setAttribute('aria-disabled', 'true');
        span.innerHTML = 'Previous';
        prevLi.appendChild(span);
      } else {
        var a = document.createElement('a');
        a.href = '#';
        a.className = 'research-projects__pagination-link research-projects__pagination-link--arrow';
        a.setAttribute('aria-label', 'Previous page');
        a.textContent = 'Previous';
        a.addEventListener('click', function (e) {
          e.preventDefault();
          setPageInUrl(currentPage - 1);
          applyPagination();
          scrollToFiltersWrap();
        });
        prevLi.appendChild(a);
      }
      ul.appendChild(prevLi);

      for (var i = 1; i <= totalPages; i++) {
        var li = document.createElement('li');
        if (i === currentPage) {
          var spanCur = document.createElement('span');
          spanCur.className = 'research-projects__pagination-link research-projects__pagination-link--active';
          spanCur.setAttribute('aria-current', 'page');
          spanCur.textContent = i;
          li.appendChild(spanCur);
        } else {
          var aCur = document.createElement('a');
          aCur.href = '#';
          aCur.className = 'research-projects__pagination-link';
          aCur.setAttribute('aria-label', 'Page ' + i);
          aCur.textContent = i;
          aCur.addEventListener('click', function (e) {
            e.preventDefault();
            setPageInUrl(parseInt(this.textContent, 10));
            applyPagination();
            scrollToFiltersWrap();
          });
          li.appendChild(aCur);
        }
        ul.appendChild(li);
      }

      var nextLi = document.createElement('li');
      if (currentPage >= totalPages) {
        var spanNext = document.createElement('span');
        spanNext.className =
          'research-projects__pagination-span research-projects__pagination-link research-projects__pagination-link--arrow research-projects__pagination-span--disabled';
        spanNext.setAttribute('aria-disabled', 'true');
        spanNext.innerHTML = 'Next';
        nextLi.appendChild(spanNext);
      } else {
        var aNext = document.createElement('a');
        aNext.href = '#';
        aNext.className = 'research-projects__pagination-link research-projects__pagination-link--arrow';
        aNext.setAttribute('aria-label', 'Next page');
        aNext.textContent = 'Next';
        aNext.addEventListener('click', function (e) {
          e.preventDefault();
          setPageInUrl(currentPage + 1);
          applyPagination();
          scrollToFiltersWrap();
        });
        nextLi.appendChild(aNext);
      }
      ul.appendChild(nextLi);

      paginationEl.appendChild(ul);
    }

    function applyCategoryFilter() {
      var activeBtn = section.querySelector('.research-projects__filter-btn.is-active');
      var filter = activeBtn ? activeBtn.dataset.filter : 'all';
      cards.forEach(function (card) {
        var rawTags = (card.dataset.tags || '')
          .split(',')
          .map(function (t) {
            return t.trim();
          })
          .filter(Boolean);
        var show = filter === 'all' || rawTags.includes(filter);
        card.classList.toggle('is-hidden', !show);
        card.classList.remove('research-projects__card--page-hidden');
      });
    }

    filterBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        filterBtns.forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
          b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
        });
        applyCategoryFilter();
        setPageInUrl(1);
        applyPagination();
      });
    });

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        setPageInUrl(1);
        applyPagination();
      });
      searchInput.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          searchInput.value = '';
          applyPagination();
          searchInput.blur();
        }
      });
    }

    applyPagination();
  })();

  } catch(e) { console.error(e); }
})();
})();
